import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Box, CircularProgress } from '@mui/material';

import { transformEventMap } from '../../utils/events';
import { EVENT_TEMPLATE_OWNERS, EVENT_TEMPLATE_TARGETS } from '../../constants/eventTemplate';
import { getEventTemplate } from 'repositories/HttpRepository';
import DecoratedEvent from 'components/DecoratedEvent';

const EventTemplates = ({ getEventList, historyId, targets, owners, filterEvent, isReverse = true, isWithoutSecond = true, urlParams = null }) => {
  const [eventMap, setEventMap] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchContentList = async () => {
    setLoading(true);
    const [events, templates] = await Promise.all([getEventList(historyId, urlParams), getEventTemplate([EVENT_TEMPLATE_TARGETS.DEFAULT, ...targets], [EVENT_TEMPLATE_OWNERS.DEFAULT, ...owners])]);
    setLoading(false);
    if (!events.ok || !templates.ok) {
      setEventMap(new Map());
      return;
    }
    let dataEvents = _.filter(events.data, filterEvent);
    dataEvents = isReverse ? _.sortBy(dataEvents, (e) => -e.ts) : _.sortBy(dataEvents, (e) => e.ts);
    let date = '';
    setEventMap(transformEventMap(date, dataEvents, templates));
  };

  useEffect(() => {
    if (!historyId) {
      setEventMap(new Map());
      return;
    }

    fetchContentList();
  }, [historyId]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        p: 2,
      }}
    >
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box className="event-template">
          <DecoratedEvent eventMap={eventMap} isWithoutSecond={isWithoutSecond} />
        </Box>
      )}
    </Box>
  );
};
export { EventTemplates };
